import { i18n } from '@/plugins/i18n'
import {gatewayStatus} from "./gatewayStatus";


export const AllShopTypes = {
     PAYMENT_HELPER : 1,
     PAYMAN : 2,
     IVR : 3,
     DEDICATED : 4,
     // COLLECTIVE : 5,
}

export const AllShopTypesStr = {
     PAYMENT_HELPER : i18n.t('reports.gateways.payment_helper'),
     PAYMAN : i18n.t('reports.gateways.payman'),
     IVR : i18n.t('reports.gateways.ivr'),
     DEDICATED : i18n.t('reports.gateways.dedicated'),
     // COLLECTIVE : i18n.t('reports.gateways.collective'),
     get(shop_type) {
          let shop_type_str = null;
          Object.keys(AllShopTypes).forEach(function (item) {
               if(AllShopTypes[item] === shop_type) {
                    shop_type_str = AllShopTypesStr[item]
               }
          })

          return shop_type_str
     }
}